import { getRoleByName } from "../../../../../models/roles"

export const canAccess = (permission, userRoles) => {
    const access = userRoles.some(role => {
      const userRole = getRoleByName(role)
      return permission.includes(userRole.id)
    })

    return access
}